function updateCardFromSwatch(radio) {
  if (!radio) return;
  const newImage = radio.dataset.image;
  const variantName = radio.dataset.variantName;
 
  const card = radio.closest('.card-wrapper');
  if (!card) return;
 
  const img = card.querySelector('[data-card-image]');
  if (img && 
  newImage  &&
  typeof newImage === 'string' &&
  !newImage.includes('Liquid error') &&
  !newImage.includes('invalid url input')) 
  {
    img.src = newImage;
    img.srcset = newImage;
  }
 
  const titleLink = card.querySelector('[data-card-title]');
  if (titleLink && variantName) {
    const baseTitle = titleLink.dataset.productTitle;
    titleLink.textContent = `${baseTitle} - ${variantName}`;
  }
}
 
/*Handle user interaction */
document.addEventListener('change', function (e) {
  if (!e.target.matches('.card-color-swatches input[type="radio"]')) return;
  updateCardFromSwatch(e.target);
});
 
/*Initialize on page load*/
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(
    '.card-color-swatches input[type="radio"]:checked'
  ).forEach(updateCardFromSwatch);
});
 